/**
 * Pendo analytics plugin
 *
 * Integrates with the global window.pendo object that is created in index.html
 *
 * Pendo global is initialized in app.root.tsx after user/org details are available so we
 * haven't added an identify method to this plugin - it's not needed, but could be done here instead one day.
 *
 * Sends track events to Pendo using pendo.track(eventName, properties)
 */
const pendoPlugin = {
  name: 'pendo',

  /**
   * Track custom events in Pendo
   * @param {object} pluginApi - Plugin API object containing payload
   */
  track: ({ payload }) => {
    if (
      typeof window === 'undefined' ||
      typeof window.pendo === 'undefined' ||
      typeof window.pendo?.track !== 'function'
    ) {
      return
    }

    console.log('Pendo track', payload)

    try {
      // Pendo.track expects (eventName, metadata)
      window.pendo.track(payload.event, payload.properties)
    } catch (error) {
      console.error('Pendo track error:', error, payload)
    }
  },

  /**
   * Check if Pendo is loaded and available
   * The analytics library uses this to determine when to send queued events to this plugin
   * @returns {boolean}
   */
  loaded: () => {
    return (
      typeof window !== 'undefined' &&
      typeof window.pendo !== 'undefined' &&
      typeof window.pendo?.isReady === 'function' &&
      window.pendo.isReady()
    )
  },
}

export default pendoPlugin
